import {FC} from 'react';

import NavLink from '~/common/NavLink/NavLink';
import {Icons} from '~/common/Icon';
import CardBordered from '~/common/display/CardBordered/CardBordered';

import s from '../styles.module.scss';
import {LinksGroupProps} from './types';

const AccountSettingsLink: FC<LinksGroupProps> = ({onClickBack}) => {
  return (
    <CardBordered className={s.card}>
      <NavLink
        icon={Icons.accountSettings}
        label="Account Settings"
        carretLeft
        onClick={onClickBack}
      />
      {/* <NavLink
        icon={Icons.changePinCode}
        label="Change Pin Code"
        asChild
      /> */}
      <NavLink
        href="/site/change-password"
        icon={Icons.changePassword}
        label="Change Password"
        asChild
      />
      <NavLink
        href="/site/change-phone"
        icon={Icons.changePhone}
        label="Change Phone Number"
        asChild
      />
      <NavLink href="/site/change-email" icon={Icons.changeEmail} label="Change Email" asChild />
      {/* <NavLink
        icon={Icons.setUpBitcoinAddress}
        label="Set-up Bitcoin Address"
        asChild
      /> */}
    </CardBordered>
  );
};

export default AccountSettingsLink;
